import React from "react";
import { useTranslation } from "react-i18next";

import {
  TEModal,
  TEModalDialog,
  TEModalContent,
  TEModalHeader,
  TEModalBody,
  TERipple,
  TEModalFooter
} from "tw-elements-react";
import AppLoading from "../../utils/AppLoading";
const ConfirmationModal = ({message, title, showModal, setShowModal, onAction, btnColor, btnText}) => {
  const{t} = useTranslation();
  const [loading, setLoading] = React.useState(false); // Add loading state
  const handleAction = async () => {
    setLoading(true); // Set loading to true before action
    await onAction(); // Call the action
    setLoading(false); // Set loading to false after action
  };

  return (
    <div>
      {/* <!-- Modal --> */}
      <TEModal show={showModal} setShow={setShowModal} staticBackdrop>
        <TEModalDialog>
          <TEModalContent>
            <TEModalHeader>
              {/* <!--Modal title--> */}
              <h5 className="text-xl font-medium leading-normal text-neutral-800 dark:text-neutral-200">
                {title}
              </h5>
              {/* <!--Close button--> */}
              <button
                type="button"
                className="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="h-6 w-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </TEModalHeader>
            {/* <!--Modal body--> */}
            <TEModalBody>
              <p className="text-start">{message}</p>
            </TEModalBody>
            <TEModalFooter>
              <TERipple rippleColor="light">
                <button
                  type="button"
                  className={`inline-block rounded ${btnColor}-100 px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-primary-700 transition duration-150 ease-in-out hover:${btnColor}-accent-100 focus:${btnColor}-accent-100 focus:outline-none focus:ring-0 active:${btnColor}-accent-200`}
                  onClick={() => setShowModal(false)}
                >
                  {t("closeBtn")}
                </button>
              </TERipple>
              <TERipple rippleColor="light">
                {loading
                ? <AppLoading height={'h-5 p-2'} size={'text-sm'} label={t("confirmDeleteLoading")}/>
                : <button
                  type="submit"
                  onClick={handleAction}
                  className={`ml-1 inline-block rounded ${btnColor} px-6 pb-2 pt-2.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:${btnColor}-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:${btnColor}-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:${btnColor}-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]`}
                  >
                  {btnText??t("confirmDeleteBtn")}
                </button>}
              </TERipple>
            </TEModalFooter>
          </TEModalContent>
        </TEModalDialog>
      </TEModal>
    </div>
  );
}

export default ConfirmationModal;